import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import "emoji-mart/css/emoji-mart.css"

import IconBase from "../Icon"
import Flex from "../Flex"

const EmojiButton = styled.div`
  cursor: pointer;
`

class EmojiPickerButton extends Component {
  static propTypes = {
    hasError: PropTypes.bool.isRequired,
    togglePickerModal: PropTypes.func.isRequired
  }

  state = {
    hover: false
  }

  handleMouseOut = () => this.setState({hover: false})
  handleMouseOver = () => this.setState({hover: true})

  render() {
    const {hover} = this.state
    const {hasError, togglePickerModal} = this.props

    return (
      <EmojiButton hasError={hasError} onClick={togglePickerModal}>
        <Flex onMouseOut={this.handleMouseOut} onMouseOver={this.handleMouseOver}>
          <IconBase icon={hover ? "emojiActive" : "emoji"} />
        </Flex>
      </EmojiButton>
    )
  }
}

export default EmojiPickerButton
